/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './intra-op-nursing-record.reducer';

export const IntraOPNursingRecordDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const intraOPNursingRecordEntity = useAppSelector(state => state.intraOPNursingRecord.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="intraOPNursingRecordDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.detail.title">IntraOPNursingRecord</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.id">Id</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.id}</dd>
          <dt>
            <span id="procedureStart">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.procedureStart">Procedure Start</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.procedureStart}</dd>
          <dt>
            <span id="procedureEnd">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.procedureEnd">Procedure End</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.procedureEnd}</dd>
          <dt>
            <span id="specimen">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.specimen">Specimen</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.specimen}</dd>
          <dt>
            <span id="timeSent">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.timeSent">Time Sent</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.timeSent}</dd>
          <dt>
            <span id="timeOfReport">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.timeOfReport">Time Of Report</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.timeOfReport}</dd>
          <dt>
            <span id="countsCorrect">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.countsCorrect">Counts Correct</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.countsCorrect ? 'true' : 'false'}</dd>
          <dt>
            <span id="surgeonInformed">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.surgeonInformed">Surgeon Informed</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.surgeonInformed ? 'true' : 'false'}</dd>
          <dt>
            <span id="timeInformed">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.timeInformed">Time Informed</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.timeInformed}</dd>
          <dt>
            <span id="actionRemarks">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.actionRemarks">Action Remarks</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.actionRemarks}</dd>
          <dt>
            <span id="actionTaken">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.actionTaken">Action Taken</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.actionTaken ? 'true' : 'false'}</dd>
          <dt>
            <span id="conditionAtEnd">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.conditionAtEnd">Condition At End</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.conditionAtEnd}</dd>
          <dt>
            <span id="equipmentProblem">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.equipmentProblem">Equipment Problem</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.equipmentProblem ? 'true' : 'false'}</dd>
          <dt>
            <span id="equipmentProblemNotes">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.equipmentProblemNotes">Equipment Problem Notes</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.equipmentProblemNotes}</dd>
          <dt>
            <span id="actionNotes">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.actionNotes">Action Notes</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.actionNotes}</dd>
          <dt>
            <span id="implant">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.implant">Implant</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.implant ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.active">Active</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{intraOPNursingRecordEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.surgery">Surgery</Translate>
          </dt>
          <dd>{intraOPNursingRecordEntity.surgery ? intraOPNursingRecordEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.scrubNurse">Scrub Nurse</Translate>
          </dt>
          <dd>{intraOPNursingRecordEntity.scrubNurse ? intraOPNursingRecordEntity.scrubNurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPNursingRecord.circulatingNurse">Circulating Nurse</Translate>
          </dt>
          <dd>{intraOPNursingRecordEntity.circulatingNurse ? intraOPNursingRecordEntity.circulatingNurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/intra-op-nursing-record" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/intra-op-nursing-record/${intraOPNursingRecordEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntraOPNursingRecordDetail;
